export var ScreenEvents;
(function (ScreenEvents) {
    ScreenEvents["SCREEN_REGISTERED"] = "screen:registered";
    ScreenEvents["SCREEN_CONNECTED"] = "screen:connected";
    ScreenEvents["SCREEN_DISCONNECTED"] = "screen:disconnected";
    ScreenEvents["SCREEN_UPDATED"] = "screen:updated";
    ScreenEvents["SCREEN_TEMPLATE_UPDATED"] = "screen:template_updated";
    ScreenEvents["SCREEN_LOCATE"] = "screen:locate";
    ScreenEvents["SCREEN_CONFIGURATION_UPDATED"] = "screen:configuration_updated";
    /** Periodic heartbeat sent by v2-capable presenters with their reported version metadata. */
    ScreenEvents["SCREEN_HEARTBEAT"] = "screen:heartbeat";
    /** Server-to-presenter command that asks the runtime to install the latest presenter release. */
    ScreenEvents["PRESENTER_UPDATE_COMMAND"] = "presenter:update_command";
    /** Presenter-to-server status for the current update attempt. */
    ScreenEvents["PRESENTER_UPDATE_STATUS"] = "presenter:update_status";
    /** Server-to-presenter command for local LED controller discovery, pairing, and status. */
    ScreenEvents["LED_CONTROLLER_COMMAND"] = "led-controller:command";
    /** Presenter-to-server progress/result for an LED apply or pairing operation. */
    ScreenEvents["LED_CONTROLLER_STATUS"] = "led-controller:status";
})(ScreenEvents || (ScreenEvents = {}));
